<!--

type
prop
label
width
fixWidth 固定宽
slot
align
fixed
sortable
children
prophtml

-->
<template>
  <div class="push-table" v-if="list.length > 0">
    <el-table :data="list" :default-sort="sortObj" @sort-change='sortTableFun' :header-cell-style="headerStyle" :max-height="heightStr"
              v-loading="loading" :row-key="getRowKeys">
      <template v-for="({ type, prop, label, width, slot, align, fixed, sortable, fixWidth, children, prophtml }, index) in config">
        <el-table-column
            :key="index"
            :label="label"
            :type="type"
            :width="width"
            :align="align"
            v-if="type"
        ></el-table-column>
        <el-table-column
            :key="index"
            :prop="prop"
            :label="label"
            :min-width="width"
            :width="fixWidth"
            :fixed="fixed"
            :align="align"
            :sortable="sortable"
            v-else-if="slot"
        >
          <template slot-scope="scope">
            <el-image v-if="slot === 'image'" :src=imageArr[scope.$index] :preview-src-list=imageArr></el-image>
            <el-input v-if="slot === 'index'" v-model="scope.$index" placeholder="请输入内容"></el-input>
            <el-input v-if="slot === 'input'" v-model="scope.row.goodsNo" placeholder="请输入内容"></el-input>
            <p v-if="slot === 'money'">{{ scope.row.moneyFormat }}</p>
            <el-link v-if="slot === 'button'" type="primary" @click="onShowDetail(scope.row)">查看</el-link>
            <p v-if="slot === 'html'" v-html="scope.row.goodsNo + '<br>' + scope.row.categoryName"></p>
            <!--            <p v-if="slot === 'button'">测试一下</p>-->
            <template v-if="slot === 'state'">
              <div :class="['status', {'stop' : scope.row.status === 2}]">
                <span v-if="scope.row.status === 1">开启</span>
                <span v-if="scope.row.status === 2">停用</span>
              </div>
            </template>
            <template v-if="slot === 'operation'">
              <div class="operation-but">
                <el-link type="primary" @click="operation('edit', scope.row)" v-if="typeStr == 'fans'">编辑</el-link>
                <el-link type="primary" @click="operation('enable', scope.row)" v-if="scope.row.status === 2">开启</el-link>
                <el-link type="danger" @click="operation('disable', scope.row)" v-if="scope.row.status === 1">停用</el-link>
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column
            :key="prop"
            :prop="prop"
            :label="label"
            :min-width="width"
            :width="fixWidth"
            :align="align"
            :sortable="sortable"
            v-else-if="children"
        >
          <el-table-column
              v-for="(itemchildren, indexchildren) in children"
              :key="indexchildren"
              :prop="itemchildren.prop"
              :min-width="itemchildren.width"
              :width="itemchildren.fixWidth"
              :label="itemchildren.label"
              show-overflow-tooltip
              :align="itemchildren.align"
              :sortable="itemchildren.sortable"
          ></el-table-column>
        </el-table-column>
        <el-table-column
            :key="prop"
            :prop="prop"
            :label="label"
            :min-width="width"
            :width="fixWidth"
            :align="align"
            :sortable="sortable"
            v-else
        ></el-table-column>
      </template>
    </el-table>
  </div>

</template>

<script>

import { defineComponent, ref, reactive, onMounted } from '@vue/composition-api'
export default defineComponent({
  name: 'Table',
  props: {
    sortObj: { // 排序
      type: Object,
      default: () => {
      }
    },
    typeStr: {
      type: String,
      default: () => ''
    },
    config: {
      type: Array,
      default: () => []
    },
    list: { // 数据列表
      type: Array,
      default: () => []
    },
    heightStr: { // 数据列表 高度
      type: String,
      default: () => '888'
    },
    loading: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      // levelList: null,
      rowKeys: 0
    }
  },
  watch: {
    $route () {
      // this.testFun();
    },
    list: {
      handler (newVal, oldVal) {
        // console.log('infoForm', newVal)
        const rQuery = this.$route.query
      },
      deep: true
    }
  },
  mounted () {
    this.$nextTick(_ => {
      // console.log(this.list)
    })
  },
  created () {},
  methods: {
    operation (oType, row) {
      const obj = { type: this.typeStr, oType, row }
      this.$emit('onOperation', obj)
    },
    onShowDetail (row) {
      console.log('onShowDetail', row)
      this.$emit('tableShowDetail', row)
    },
    // 表格表头合并
    headerStyle ({ row, rowIndex }) {},
    sortTableFun (column) {
      console.log('sortTableFun 排序', column)
    },
    getRowKeys (row) {
      // console.log(row)
      // return row.code + row.type
      return row.id
    }

  },
  setup() {
    // onMounted(() => { console.log('onMounted') });
  }
})
</script>
<style lang="scss">
.push-table{
   .el-table {
    text-align: unset;
    border-top: 1px solid #e8eaec;
    border-left: 1px solid #e8eaec;
    border-right: 1px solid #e8eaec;
    .el-table__header{
      .has-gutter{
        th{
          background-color: #f8f8f8;
          font-size: 16px;
          font-weight: bold;
          color: #333333;
        }
      }
    }
    .el-table__body{
      .el-table__row{
        .el-table__cell{

        }
      }
    }
  }
  .status span{
    &:before{
      width: 10px;
      height: 10px;
      border-radius: 50%;
      overflow: hidden;
      display: inline-block;
      content: '';
      background-color: #0b7df3;
      margin-right: 5px;
    }
  }
  .status.stop span:before{background-color: #F33F3F;}
  .operation-but{
    a {
      font-size: 14px;
      font-weight: 400;
    }
    a + a { margin-left: 10px; }
  }
}


</style>
